import { UseFormRegister, Control } from 'react-hook-form';
import type { TabItem } from './types';
import { InquiryForm, Smtp } from '../../../models/Inquiry/Inquiry';
import FormRow from './FormRow';

export const OshiraseTabs: TabItem[] = [
  { name: 'Notification settings', value: 'oshirase_settings', tabval: 1 },
];

const OshiraseTabContents = ({
  smtps,
  templates,
  register,
  control,
  currentTab,
}: {
  smtps: Smtp[],
  templates: { id: number; name: string }[],
  currentTab: number,
  register: UseFormRegister<InquiryForm>,
  control: Control<InquiryForm>,
}) => (
  <>
    <div className={`tab-pane ${currentTab === 1 ? 'active' : ''}`} role="tabpanel">
      <FormRow
        key="captcha"
        name="CAPTCHA"
        register={register}
        key_value={'captcha' as keyof InquiryForm}
      />

      <FormRow
        key="confirm_page"
        name="Confirmation screen"
        register={register}
        key_value={'confirm_page' as keyof InquiryForm}
      />

      <FormRow
        key="receiving_mail_address"
        name="Inquiry receiving email address"
        type="text"
        register={register}
        key_value={'receiving_mail_address' as keyof InquiryForm}
      />

      <FormRow
        key="mail_template_id"
        name="Email template"
        type="select"
        register={register}
        control={control}
        key_value={'mail_template_id' as keyof InquiryForm}
        options={[
          { value: 0, label: 'System email template' },
          ...templates.map((template) => ({
            value: template.id,
            label: template.name,
          })),
        ]}
      />

      <FormRow
        key="smtp_id"
        name="SMTP selection"
        type="select"
        register={register}
        control={control}
        key_value={'smtp_id' as keyof InquiryForm}
        options={[
          { value: 0, label: 'System SMTP' },
          ...smtps.map((smtp) => ({
            value: smtp.id,
            label: smtp.smtp_mail,
          })),
        ]}
      />
    </div>
  </>
);

export default OshiraseTabContents;
